var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SubHeader',{attrs:{"text":_vm.$t('h.gaa'),"imgUrl":_vm.imgUrl}}),_vm._v(" "),_c('div',{staticClass:"global-img"},[_c('img',{attrs:{"src":_vm.imgUrl1,"alt":"image"}})]),_vm._v(" "),_c('Content0')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ccd36b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/GlobalAppAccess/GlobalAppAccess.vue
// module id = null
// module chunks = 